import React, { Component } from 'react';
import Header from '../header';
import MetaTags from 'react-meta-tags';
import logo from '../common/app2soft/images/logo_color_140X40.png';
import Footer from '../footer';
import Main from './views/main';
import './style.scss';

class BuildYourTeam extends Component{
  constructor(props){
    super(props);
    this.complete = this.complete.bind();
  }

  complete = () => {
    this.props.history.push('/build-your-team/thank-you');
  }

  render(){
    return(
      <div key="build-page" className="page">
        <MetaTags>
          <title>{`App2soft | Build your Team`}</title>
          <meta name="description" content="Estimate your nearshore development team cost" />
          <meta name="keywords" content="software development team, outsourcing it services, development team" />
          <meta name="author" content="Upway Solutions" />
          <meta property="og:image" content={`${logo}`} />
        </MetaTags>
        <Header key='page-header' animation={false} page="landing"/>
        <Main menu="active" complete={this.complete}/>
      </div>
    ) 
  }
} 

export default BuildYourTeam;



// WEBPACK FOOTER //
// ./src/components/build-your-team/index.js